import { gsap } from 'gsap';
function Animate(sprite, { duration = 1, speed = 1, ease = 'Cubic.easeIn', index, istemplate }) {
  var finalAlpha = sprite.alpha;
  sprite.alpha = 0;
  var y = sprite.y;
  sprite.y = sprite.y + 20;
  let delay = 0;
  if (istemplate && index) {
    delay = index * (duration * speed);
  }
  var animation = gsap.to(sprite, {
    pixi: { y: y, alpha: finalAlpha },
    duration: duration * speed,
    ease: 'slow(0.3, 0.7, false)',
    paused: true,
    delay: delay,
  });
  return animation;
}
export default { Animate };
